import { render } from "./publicacioneshome.vue?vue&type=template&id=17255852&scoped=true"
import script from "./publicacioneshome.vue?vue&type=script&lang=js"
export * from "./publicacioneshome.vue?vue&type=script&lang=js"

import "./publicacioneshome.vue?vue&type=style&index=0&id=17255852&scoped=true&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17255852"]])

export default __exports__